import * as React from "react";

function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

type Variant = "default" | "success" | "error" | "warning";

const base =
  "group pointer-events-auto relative flex w-full items-center gap-3 overflow-hidden rounded-xl border p-4 shadow-app-lg transition-all";
const variants: Record<Variant, string> = {
  default:
    "bg-app-surface-elevated text-app-text border-app-border",
  success:
    "bg-app-success-bg text-app-success-text border-app-success",
  error:
    "bg-app-error-bg text-app-error-text border-app-error",
  warning:
    "bg-app-warning-bg text-app-warning-text border-app-warning",
};

export interface ToastProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  variant?: Variant;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export function Toast({
  className,
  variant = "default",
  title,
  description,
  action,
  ...props
}: ToastProps) {
  return (
    <div
      role="status"
      className={cn(base, variants[variant], className)}
      {...props}
    >
      <div className="flex-1 min-w-0">
        {title && <div className="font-medium">{title}</div>}
        {description && <div className="text-sm opacity-80">{description}</div>}
      </div>
      {action}
    </div>
  );
}

export function ToastViewport(props: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className="fixed bottom-24 right-4 left-4 md:left-auto md:bottom-4 md:w-[360px] z-[9999] flex flex-col gap-2 max-w-[calc(100vw-2rem)] md:max-w-[360px]"
      {...props}
    />
  );
}

export const ToastProvider = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);



